import { Component } from '@angular/core'; 
import { AuthHeaderComponent } from '../../layout/auth-header/auth-header.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth',
  imports: [AuthHeaderComponent,RouterOutlet],
  standalone: true,
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {

}
